import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ssApiService } from 'app/services/ss-api.service';


@Component({
  selector: 'redirect',
  templateUrl: './redirect.html'
})
export class Redirect implements OnDestroy {
  // DATA SUBSCRIPTION VARIABLES
  paramsSubscribe: any;

  constructor(private api: ssApiService, private route: ActivatedRoute) {

    this.paramsSubscribe = this.route.params.subscribe(params => {

      if (params != undefined)
        this.ProcessParameters(params);
    });

  }

  ngOnDestroy() {
    this.paramsSubscribe.unsubscribe();
  }

  ProcessParameters(params: object) {

    // get parameter
    let RedirectID = params['redirectID'];

    // check and save to local storage
    if (RedirectID != undefined)
      localStorage.setItem('s_redirect_id', RedirectID);
    else
      window.location.href = 'http://www.structurestudios.com';


    localStorage.setItem('s_redirect_created', new Date().toString());


    // get the data from server
    let subscribe = this.api.ReferralRedirect(RedirectID).subscribe(
      (redirect) => {
        subscribe.unsubscribe();

        if (redirect.Result)
          window.location.href = redirect.Data.ForwardUrl;
        else
          window.location.href = 'http://www.structurestudios.com';

      },
      (error) => {
        window.location.href = 'http://www.structurestudios.com';
      });

  }


}
